/* ms-brand.js, S!KE (modèle Ojersey, outils MLF MODE). Chargé en différé, sans dépendance.
   1. boutons « Commander » hors du formulaire : ouvrent Releasit, sinon remontent au bouton de commande
   2. relais des événements du formulaire Releasit, point de branchement d'un futur pixel */
(function () {
  'use strict';

  // ---- 1. Boutons « Commander » ------------------------------------------------
  // Releasit place son bouton dans le formulaire produit de Dawn. On clique dessus,
  // ou on ouvre sa fenêtre par son API. S'il n'est pas chargé, on remonte au formulaire.
  var RSI_BUTTONS = [
    '#rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '[id^="rsi"] button'
  ];
  function releasitButton() {
    for (var i = 0; i < RSI_BUTTONS.length; i++) {
      var el = document.querySelector(RSI_BUTTONS[i]);
      if (el && !el.closest('[data-ms-order]')) return el;
    }
    return null;
  }
  function order() {
    var btn = releasitButton();
    if (btn) { btn.click(); return; }
    try {
      var v2 = window._rsiV2;
      if (v2 && typeof v2.setState === 'function') { v2.setState({ isOpen: true }); return; }
    } catch (e) {}
    var form = document.querySelector('product-form, .product-form, product-info');
    if (form) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      form.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    }
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-ms-order]') : null;
    if (!t) return;
    e.preventDefault();
    order();
  });

  // ---- 2. Relais d'événements -----------------------------------------------------
  // Aucun pixel au lancement. Point de branchement :
  //   document.addEventListener('ms:formulaire_ouvert', ...)
  //   document.addEventListener('ms:commande_passee', function (e) { e.detail.order })
  var sent = {};
  function emit(name, detail, key) {
    if (sent[key]) return;
    sent[key] = true;
    try { document.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); } catch (e) {}
  }
  document.addEventListener('rsi::v2::update', function (e) {
    var d = (e && e.detail) || {};
    if (d.orderResponse) emit('ms:commande_passee', { order: d.orderResponse }, 'order');
    else if (d.isOpen) emit('ms:formulaire_ouvert', {}, 'open');
  });

  // Listes à glisser de Dawn (colonnes « Comment l'utiliser » sur téléphone) sans lien ni bouton :
  // atteignables au clavier pour pouvoir les faire défiler avec les flèches.
  function sliders() {
    document.querySelectorAll('ul.slider').forEach(function (s) {
      if (s.hasAttribute('tabindex') || s.querySelector('a, button, input, select, textarea, [tabindex]')) return;
      s.setAttribute('tabindex', '0');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sliders); else sliders();
})();

// ---- 3. Photos de la grille de l'accueil, après la photo d'ouverture (MLF MODE, 2026-10-16) ----------------------------
// snippets/ms-grille.liquid (hors page collection) met l'adresse de la photo dans data-ms-src. On attend que la photo
// d'ouverture soit arrivée (ou 4 s au plus), puis chaque photo part quand sa carte approche de l'écran (300 px).
// S!KE (2026-10-19) : l'ouverture, ce sont les deux tuiles TOPS et PANTS (.ms-cats--ouverture) ; on attend la dernière des deux.
(function () {
  'use strict';
  var imgs = Array.prototype.slice.call(document.querySelectorAll('img[data-ms-src]'));
  if (!imgs.length) return;
  function charger(img) {
    if (!img.hasAttribute('data-ms-src')) return;
    if (img.getAttribute('data-ms-srcset')) img.setAttribute('srcset', img.getAttribute('data-ms-srcset'));
    img.setAttribute('src', img.getAttribute('data-ms-src'));
    img.removeAttribute('data-ms-src');
    img.removeAttribute('data-ms-srcset');
  }
  var parti = false;
  function partir() {
    if (parti) return;
    parti = true;
    if (!('IntersectionObserver' in window)) { imgs.forEach(charger); return; }
    var io = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); charger(e.target); } });
    }, { rootMargin: '300px 0px' });
    imgs.forEach(function (img) { io.observe(img); });
  }
  var ouvertures = Array.prototype.slice.call(document.querySelectorAll('.ms-cats--ouverture img, [data-ms="hero"] img'))
    .filter(function (img) { return !(img.complete && img.naturalWidth > 0); });
  if (ouvertures.length) {
    var reste = ouvertures.length;
    var fin = function () { reste -= 1; if (reste <= 0) partir(); };
    ouvertures.forEach(function (img) {
      img.addEventListener('load', fin, { once: true });
      img.addEventListener('error', fin, { once: true });
    });
    setTimeout(partir, 4000);
  } else {
    partir();
  }
})();

// ---- 4. Galerie de la fiche : photos 2 et suivantes après la première (MLF MODE, 2026-10-16) --------------------------
// snippets/product-thumbnail.liquid (copie de Dawn) met leur adresse dans data-ms-galerie-src. Elles partent toutes dès que
// la première photo de la galerie est arrivée (ou 4 s au plus) : rien n'attend un défilement, le carrousel reste prêt.
(function () {
  'use strict';
  var imgs = Array.prototype.slice.call(document.querySelectorAll('img[data-ms-galerie-src]'));
  if (!imgs.length) return;
  var parti = false;
  function partir() {
    if (parti) return;
    parti = true;
    imgs.forEach(function (img) {
      if (img.getAttribute('data-ms-galerie-srcset')) img.setAttribute('srcset', img.getAttribute('data-ms-galerie-srcset'));
      img.setAttribute('src', img.getAttribute('data-ms-galerie-src'));
      img.removeAttribute('data-ms-galerie-src');
      img.removeAttribute('data-ms-galerie-srcset');
    });
  }
  var premiere = document.querySelector('media-gallery .product__media-item img:not([data-ms-galerie-src])');
  if (premiere && !(premiere.complete && premiere.naturalWidth > 0)) {
    premiere.addEventListener('load', partir, { once: true });
    premiere.addEventListener('error', partir, { once: true });
    setTimeout(partir, 4000);
  } else {
    partir();
  }
})();

// ---- 5. Couleurs de la fiche : la photo et la vignette vont ensemble (S!KE, 2026-10-19) --------------------------------
// Ordre du client (vocal du 2026-10-19 17:36Z) : une fiche par modèle ; on entre, on fait glisser, on a la couleur. Ne touche
// qu'aux fiches dont la couleur est en vignettes (snippets/product-variant-picker.liquid, fieldset [data-ms="couleurs"]).
//  a. Faire glisser la galerie (téléphone) ou cliquer une miniature (ordinateur) choisit la couleur de la photo montrée,
//     comme un toucher sur sa vignette : la commande part dans la couleur qu'on voit. Sans cela, une cliente qui faisait
//     glisser jusqu'au bordeaux commandait la couleur d'arrivée.
//  b. Choisir une couleur amène la galerie sur sa photo SANS la réordonner. Dawn remet la photo choisie en tête
//     (updateMedia, puis setActiveMedia avec prepend) : le carrousel sautait sous le doigt pendant qu'on le faisait glisser.
//     Pour la même fiche, la galerie a les mêmes photos d'une couleur à l'autre : il suffit de l'amener sur la bonne.
//  c. et d. La variante de la couleur touchée part dans le formulaire d'achat, et sa photo est montrée, sans attendre Dawn.
(function () {
  'use strict';
  if (!window.customElements || !document.querySelector('product-info [data-ms="couleurs"]')) return;

  // b. Galerie à ordre fixe. Repli sur Dawn si la galerie reçue n'a pas les mêmes photos (autre fiche, photos masquées).
  customElements.whenDefined('product-info').then(function () {
    var proto = customElements.get('product-info').prototype;
    var dawn = proto.updateMedia;
    if (typeof dawn !== 'function' || proto.msOrdreFixe) return;
    proto.msOrdreFixe = true;
    var ids = function (ul) {
      return Array.prototype.map.call(ul.querySelectorAll('li[data-media-id]'), function (li) { return li.dataset.mediaId; }).sort().join();
    };
    proto.updateMedia = function (html, idPhoto) {
      var galerie = this.querySelector('media-gallery');
      var ici = galerie && galerie.querySelector('ul');
      var recue = html && html.querySelector('media-gallery ul');
      if (!idPhoto || !this.querySelector('[data-ms="couleurs"]') || !ici || !recue || ids(ici) !== ids(recue) || typeof galerie.setActiveMedia !== 'function') {
        return dawn.apply(this, arguments);
      }
      galerie.setActiveMedia(this.dataset.section + '-' + idPhoto, false);
    };
  });

  // a. La photo montrée choisit la couleur.
  function brancher(info) {
    var galerie = info.querySelector('media-gallery');
    var section = info.dataset.section;
    if (!galerie || !section || galerie.hasAttribute('data-ms-couleurs')) return;
    galerie.setAttribute('data-ms-couleurs', '');
    // Dernier geste de la cliente sur la galerie : seul un défilement qu'elle a fait choisit une couleur, pas celui par lequel
    // Dawn amène la photo d'une couleur touchée.
    var geste = 0;
    var marquer = function () { geste = Date.now(); };
    ['pointerdown', 'touchstart', 'touchmove', 'touchend', 'wheel', 'keydown'].forEach(function (t) {
      galerie.addEventListener(t, marquer, { passive: true });
    });
    var attente = null;
    var nous = false;
    function choisir(idGalerie) { // « <section>-<id de la photo> »
      var couleurs = info.querySelector('[data-ms="couleurs"]');
      if (!couleurs || !idGalerie || idGalerie.indexOf(section + '-') !== 0) return;
      var input = couleurs.querySelector('input[data-ms-media="' + idGalerie.slice(section.length + 1) + '"]');
      if (!input || input.checked) return;
      // Dawn redonne le focus à l'option choisie une fois la fiche relue : sur téléphone, la page défilerait jusqu'aux
      // vignettes pendant qu'on regarde la photo. Un id provisoire, remis juste après l'envoi, le lui fait manquer.
      var vrai = input.id;
      input.id = vrai + '-ms';
      input.checked = true;
      nous = true;
      try { input.dispatchEvent(new Event('change', { bubbles: true })); } finally { nous = false; input.id = vrai; }
    }
    // c. Le formulaire d'achat prend la variante de la couleur dès le toucher. Dawn ne l'y pose qu'une fois la fiche relue
    //    (0,2 à 1 s) : « Commander » touché entre-temps ouvrait Releasit sur la couleur d'avant (mesuré le 2026-10-19 sur
    //    l'aperçu v3 : rose pâle touchée, « Chocolat » dans le formulaire Releasit).
    function poserVariante(input) {
      var id = input.getAttribute('data-ms-variant');
      if (!id) return;
      info.querySelectorAll('#product-form-' + section + ', #product-form-installment-' + section).forEach(function (form) {
        var champ = form.querySelector('input[name="id"]');
        if (!champ || champ.value === id) return;
        champ.value = id;
        champ.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    // d. La photo de la couleur touchée est montrée tout de suite. Dawn ne l'amène qu'une fois la fiche relue, et pas du
    //    tout si la relecture échoue (mesuré le 2026-10-19 pendant une salve de 429 : bleu marine coché, photo restée sur
    //    le bordeaux ; le formulaire, lui, était juste grâce à c).
    function montrer(input) {
      var photo = input.getAttribute('data-ms-media');
      if (photo && typeof galerie.setActiveMedia === 'function') galerie.setActiveMedia(section + '-' + photo, false);
    }
    info.addEventListener('change', function (e) {
      var input = e.target.closest && e.target.closest('[data-ms="couleurs"] input[type="radio"]');
      if (!input) return;
      poserVariante(input);
      if (nous) return;
      montrer(input);
      // Une vignette touchée par la cliente l'emporte sur un arrêt de la galerie encore en attente.
      clearTimeout(attente);
      geste = 0;
    });
    // Téléphone : carrousel à glisser (liste « Slider-… » de Dawn) ; on attend qu'il s'arrête sur une photo.
    var viewer = galerie.querySelector('[id^="GalleryViewer"]');
    var liste = viewer && viewer.querySelector('[id^="Slider-"]');
    if (liste) liste.addEventListener('scroll', function () {
      clearTimeout(attente);
      attente = setTimeout(function () {
        if (Date.now() - geste > 1500) return;
        var items = Array.prototype.filter.call(liste.querySelectorAll('li[data-media-id]'), function (li) { return li.clientWidth > 0; });
        if (items.length < 2) return;
        var pas = items[1].offsetLeft - items[0].offsetLeft;
        if (pas <= 0) return;
        var i = Math.min(items.length - 1, Math.max(0, Math.round(liste.scrollLeft / pas)));
        choisir(items[i].dataset.mediaId);
      }, 180);
    }, { passive: true });
    // Ordinateur : miniatures sous la photo (Dawn y montre la photo ; ici, sa couleur est choisie aussi).
    galerie.addEventListener('click', function (e) {
      var mini = e.target.closest && e.target.closest('[id^="GalleryThumbnails"] [data-target]');
      if (mini) choisir(mini.getAttribute('data-target'));
    });
  }
  document.querySelectorAll('product-info').forEach(brancher);
})();
